import React from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import AccountCircle from "../other-icons/AccountCircle";
import ArrowRight from "../other-icons/ArrowRight";
import "./account-btn.m.css";

const AccountBtn = ({ signinHandler, onAccountHandler, style }) => {
  const isUserLogin = useSelector((state) => get(state, ["isLogin"], false));

  return (
    <button
      styleName="btn"
      style={style}
      onClick={isUserLogin ? onAccountHandler : signinHandler}
      aria-label="Account"
    >
      {!isUserLogin && (
        <span styleName="arrow-icon">
          <ArrowRight />
        </span>
      )}
      <AccountCircle />
    </button>
  );
};

export default AccountBtn;
